import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-arrow-angle-right-white",
  "use": "sd-arrow-angle-right-white-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-arrow-angle-right-white\"><path d=\"M11.995 6.707a.5.5 0 11.712-.702l5.707 6.005-5.707 5.995a.5.5 0 01-.702-.712L17 12l-5.005-5.293z\" fill=\"#fff\" /><path d=\"M9.605 17.541a1.498 1.498 0 01-2.158 0 1.597 1.597 0 010-2.216L10.684 12 7.447 8.675a1.597 1.597 0 010-2.216 1.498 1.498 0 012.158 0L15 12l-5.395 5.541z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol